import React from 'react';

export default function Main({ children }: any) {
  return (
    <main style={{ gridArea: 'main' }} className="bg-[#F1F4F9]">
      {children}
    </main>
  );
}
